declare global {
    interface Window {
        mnsv2: (arg1: string, arg2: string) => string;
        ck?: string;
    }
}

// Node / Bun / Browser 兼容的 window 对象
let _windowCache: (Window & Record<string, unknown>) | null = null;

const getWindow = (): Window & Record<string, unknown> => {
    if (_windowCache) return _windowCache;

    if (typeof window !== "undefined") {
        // 浏览器环境
        _windowCache = window as unknown as Window & Record<string, unknown>;
    } else if (typeof global !== "undefined") {
        // Node.js 环境
        _windowCache = globalThis as unknown as Window & Record<string, unknown>;
    } else {
        // 其他环境
        _windowCache = globalThis as unknown as Window & Record<string, unknown>;
    }

    return _windowCache;
};

// ⭐ 必须最先注册（关键）
if (typeof process !== "undefined") {
    process.on("uncaughtException", () => {});
    process.on("unhandledRejection", () => {});
}

const mnsv2_enc = (arg1: string, arg2: string, cookieString: string): string => {
    const win = getWindow();
    win.ck = cookieString;

    require("./ob.env");
    try {
        require("./ob.enc");
    } catch {}

    let result = "";

    try {
        result = win.mnsv2(arg1, arg2);
    } catch {
        // 同步异常（极少数）
    }

    return result;
};

export default mnsv2_enc;
